/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { useMemo } from "react";
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionHeadline from '../../../components/SectionHeadline';
import CardList from '../../../components/CardList'
import { useLocalization } from "gatsby-theme-i18n";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';
import { DateTime } from 'luxon';
import RoundButton from "../../../components/RoundButton";


const ProgramSection = ({ list, title, subtitle, category, id, background, button }) => {

  const {localeKey } = useLocalization();

const programsList = useMemo(() => {
  if(list)
  {
    let tempList = [];
    list.edges.forEach((item) => {
      tempList.push({
        category: '',
        title: item.node.title ? item.node.title[localeKey] : '',
        desc: item.node.desc ? item.node.desc[localeKey] : '',
        image: getImage(item.node.thumb),
        visual : getImage(item.node.visual),
        data: item.node.data,
        time: item.node.time ? item.node.time[localeKey] : '',
        isNew: DateTime.fromISO(item.node.data.update_date).diff(DateTime.local(), [ 'days']).values.days > -3,
        annotation : item.node.annotation ? item.node.annotation[localeKey] : '',
        guests : item.node.guests,
        performers : item.node.performers ? item.node.performers[localeKey] : '',
        streamingUrl : item.node.data.stream_url
      });
    });
    // console.log(data.programsList.edges);
    

    return tempList;
  } else {
    return [];
  }

  
},[list,localeKey ]);

  return (
    <SectionWrapper id={`section_program_${id}`} className={`programList`}>
      <AnimatedSection>
        <Content>
          <SectionHeadline title={title} subtitle={subtitle} category={category} />
          <CardList colNum={3} list={programsList} isFull={"true"} hvModal={true}/>
          {button &&
            <ButtonContainer>
              <RoundButton color={"#4E4E50"} size={"large"} to={button.to} css={css`
                @media only screen and (max-width: ${breakpoint.smMax}){
                  font-size: 16px;
                  line-height: 24px;
                  padding:12px 24px;
                  height:auto;
                }
                @media only screen and (max-width: ${breakpoint.xsMax}){
                  font-size: 14px;
                  line-height: 20px;
                  padding:8px 16px;
                }
              `}>{button.label}</RoundButton>
            </ButtonContainer>
          }
        </Content>
      </AnimatedSection>
      <Background position={background.position}><GatsbyImage image={getImage(background.image)} alt={"background"} /></Background>
    </SectionWrapper>
  );
};


export default ProgramSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  display:flex;
  align-items:center;
  position:relative;
  padding:96px 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
    min-height:728px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    padding:32px 0;
    min-height:0;
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  z-index:5;
  max-width: calc(960px + 96px);
`

const Background = styled.div`
  width:720px;
  height:auto;
  position:absolute;
  top:0;
  ${props => props.position === "right" ? `right:0;` : `left:0;`}

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:359px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const ButtonContainer = styled.div`
  text-align: center;
`
